import React from 'react'
import {Icon} from '@therms/atalaya'
import {MobileMenuLink} from '@src/modules/Layout/shared/MobileMenuLink'
import {REPORTS_ROUTES} from '../../constants'
import {IoDocumentTextSharp} from 'react-icons/io5'

function ReportsMobileMenuLink() {
  return (
    <MobileMenuLink to={REPORTS_ROUTES.__ROOT__}>
      <div className="flex flex-col items-center">
        <Icon Icon={IoDocumentTextSharp} />
        <span>Reports</span>
      </div>
    </MobileMenuLink>
  )
}

export {ReportsMobileMenuLink}
